import { FORGOT_SET_FORM, FORGOT, RESET_PASSWORD } from "./actions.type";
import { SET_FORGOT_FORM } from "./mutations.type";
import { COMPANY_ID } from "@/common/config.js";
import ApiService from "@/common/api.service";

const state = {
  errors: {},
  form: {
    new_password: null,
    new_password_confirmation: null
  }
};
const getters = {
  forgot(state) {
    return state.form;
  }
};

const actions = {
  [FORGOT_SET_FORM]({ commit }, payload) {
    commit(SET_FORGOT_FORM, payload);
  },
  [FORGOT](_, value) {
    return ApiService.post("v1/customers/send_reset_password_mail", {
      company_id: COMPANY_ID,
      email: value
    });
  },
  [RESET_PASSWORD](_, payload) {
    ApiService.patch("v1/customers/reset_password", payload);
  }
};

const mutations = {
  [SET_FORGOT_FORM](state, payload) {
    state.form = { ...state.form, ...payload };
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
